import { RolesWithPermissions } from '../';

export const MESSAGES_ROLES: RolesWithPermissions = {
  admin: {
    messages: {
      view: true,
      create: false,
    },
  },
  general: {
    messages: {
      view: true,
      create: false,
    },
  },
  supervisor: {
    messages: {
      view: true,
      create: true,
    },
  },
  backoffice: {
    messages: {
      view: true,
      create: true,
    },
  },
  client: {
    messages: {
      view: true,
      create: true,
    },
  },
  agency: {
    messages: {
      view: true,
      create: true,
    },
  },
  '3rd_inspector': {
    messages: {
      view: false,
      create: false,
    },
  },
  inspector: {
    messages: {
      view: false,
      create: false,
    },
  },
};
